import type { TSGBrand } from './types/TSGBrand';

type GetBrandsToDisplayParams = {
  displayAutopayBrand?: boolean;
  displayRateGeniusBrand?: boolean;
  displayTreslBrand?: boolean;
};

export const getBrandsToDisplay = ({
  displayAutopayBrand = true,
  displayRateGeniusBrand = true,
  displayTreslBrand = true,
}: GetBrandsToDisplayParams = {}): TSGBrand[] => {
  const brandsToDisplay: TSGBrand[] = ['autopay', 'rateGenius', 'tresl'];

  const removeBrand = (brand: TSGBrand) => {
    brandsToDisplay.splice(brandsToDisplay.indexOf(brand), 1);
  };

  // ensure at least one of these brands is displayed, else ignore the display settings
  if (displayAutopayBrand || displayRateGeniusBrand || displayTreslBrand) {
    if (!displayAutopayBrand) {
      removeBrand('autopay');
    }

    if (!displayRateGeniusBrand) {
      removeBrand('rateGenius');
    }

    if (!displayTreslBrand) {
      removeBrand('tresl');
    }
  }

  return brandsToDisplay;
};
